import trackProductEvent from '../../utils/trackProductEvent';
import { LIMITED_STOCK, OUT_OF_STOCK } from '../../helpers/availability';

const formattedTrackingSku = ({ sku, bagItem }) => {
  return {
    sku_id: sku.id,
    limited_stock: sku.inventory.availability === LIMITED_STOCK,
    out_of_stock: sku.inventory.availability === OUT_OF_STOCK,
    quantity: bagItem?.quantity,
    source: 'ungated_shop',
    sub_source: bagItem?.sub_source,
  };
};

const formattedTrackingSkus = ({ skus, bagItems }) => {
  return skus.map(sku => {
    const bagItem = bagItems[sku.id];

    return formattedTrackingSku({ sku, bagItem });
  });
};

// This event should fire when a customer views the ungated shopping bag page
export const trackShoppingBagView = ({ skus, bagItems }) => {
  const allSkusOutOfStock =
    skus.length === 0
      ? false
      : skus.every(sku => sku.inventory.availability === OUT_OF_STOCK);

  const eventName = 'ungated_shopping_bag_view';
  const canonicalName = 'shopping_bag';
  const actionType = 'view';
  const actionName = 'page_view';
  const actionDetail = 'ungated_shop';
  const directBuyContext = {
    all_items_out_of_stock: allSkusOutOfStock,
    skus: formattedTrackingSkus({ skus, bagItems }),
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

// This event should fire when a customer clicks the CTA on the shopping bag page
export const trackReviewOrderClick = () => {
  const eventName = 'ungated_shopping_bag_checkout';
  const canonicalName = 'shopping_bag';
  const actionType = 'click';
  const actionName = 'click_into_checkout';
  const actionDetail = 'ungated_shop';

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
  });
};

export const trackBagIconClick = canonicalName => {
  const eventName = 'bag_icon_click';
  const actionType = 'click';
  const actionName = 'bag_icon_click';
  const actionDetail = 'ungated_shop';

  return trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
  });
};

export const trackAddToBagEvent = ({ sku, bagItem }) => {
  const eventName = 'ungated_shopping_bag_increment';
  const canonicalName = 'shopping_bag';
  const actionType = 'click';
  const actionName = 'add_to_bag';
  const actionDetail = 'ungated_shop';
  const trackingSku = formattedTrackingSku({ sku, bagItem });
  const directBuyContext = { skus: [trackingSku] };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

export const trackRemoveBagItemEvent = ({ sku, bagItem }) => {
  const eventName = 'ungated_shopping_bag_decrement';
  const canonicalName = 'shopping_bag';
  const actionType = 'click';
  const actionName = 'remove_item';
  const actionDetail = 'ungated_shop';
  const trackingSku = formattedTrackingSku({ sku, bagItem });
  const directBuyContext = { skus: [trackingSku] };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

export const trackEmptyBagCtaClick = () => {
  const eventName = 'empty_bag_cta_click';
  const canonicalName = 'shopping_bag';
  const actionType = 'click';
  const actionName = 'style_quiz_cta';
  const actionDetail = 'ungated_shop';

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
  });
};
